enum PaymentAction {
  RELEASE = 'release',
  DENY = 'deny'
}

export default PaymentAction;
